import FormController from 'controllers/form-controller';
import Rails from 'rails-ujs';
import events from 'lib/events';
import { trim, triggerCustomEvent } from 'lib/helpers';

import { sanitizeTerm } from 'lib/search-helpers';

export default class CollectionsModalFormController extends FormController {
  static targets = [
    'collectionsList',
  ];

  connect() {
    this.searchForm = document.querySelector('[data-controller="collections-search-form"]');

    this.collectionPrivacyField = this.element.querySelector('#collection_private');
    this.collectionSaveAction = this.element.getAttribute('action');

    triggerCustomEvent('hidePromoPopup');
  }

  saveNewCollection = (event) => {
    event.preventDefault();
    triggerCustomEvent(events.collections.created, {});

    this.validateFields(() => {
      if (this.collectionWithName()) {
        this.saveToCollection(event);
      } else {
        this.element.setAttribute('action', this.collectionSaveAction);

        this.saveCollection();
      }
    });
  }

  saveToCollection = (event) => {
    event.preventDefault();
    triggerCustomEvent(events.collections.resource_added, {});

    const targetCollection = this.targetIsCollectionListItem(event.currentTarget)
      ? event.currentTarget : this.collectionWithName();

    const collectionId = targetCollection.getAttribute('data-collection-id');
    const collectionPrivacy = targetCollection.getAttribute('data-privacy');

    this.searchForm.value = trim(targetCollection.querySelector('.collections-list__item__name').innerHTML);

    this.collectionPrivacyField.value = collectionPrivacy;

    this.element.setAttribute('action', `${this.collectionSaveAction}/${collectionId}/items`);

    this.saveCollection();
  }

  saveCollection = () => {
    this.element.addEventListener('ajax:success', (event) => {
      const collectionAlertHTML = event.detail[0].body.innerHTML;
      document.body.insertAdjacentHTML('beforeend', collectionAlertHTML);
    });

    Rails.fire(this.element, 'submit');

    triggerCustomEvent(events.modal.close_modal);

    return true;
  }

  validateFields(callback) {
    super.validateFields();

    if (this.formValid) {
      callback();
    }
  }

  collectionWithName() {
    const collectionName = sanitizeTerm(this.searchForm.value);
    if (trim(collectionName).length <= 0) return false;
    return this.collectionsListTarget.querySelector(`[data-collection-name="${collectionName}"]`);
  }

  targetIsCollectionListItem(target) {
    return target.getAttribute('data-target').indexOf('collections-modal.collectionsListItem') > -1;
  }
}
